import { render, staticRenderFns } from "./Answer_intellect_guide.vue?vue&type=template&id=333adf82&scoped=true&"
import script from "./Answer_intellect_guide.vue?vue&type=script&lang=js&"
export * from "./Answer_intellect_guide.vue?vue&type=script&lang=js&"
import style0 from "./Answer_intellect_guide.vue?vue&type=style&index=0&id=333adf82&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333adf82",
  null
  
)

export default component.exports